import { ReportFeatures } from '@hcs/types';

export const COMP_PHOTO_CAROUSEL_FEATURES_SALE = [
  ReportFeatures.CompsPhotosCurrent,
  ReportFeatures.CompsStreetview,
  ReportFeatures.Tags,
];

export const COMP_PHOTO_CAROUSEL_FEATURES_RENTAL = [
  ReportFeatures.RentalCompsPhotosCurrent,
  ReportFeatures.RentalCompsStreetview,
  ReportFeatures.Tags,
];
